import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Target } from "lucide-react";

const kleur = (pct) => (pct == null ? "bg-slate-400" : pct >= 100 ? "bg-emerald-500" : pct >= 75 ? "bg-amber-500" : "bg-rose-500");

function Balk({ label, behaald, doel, pct, tid }) {
  return (
    <div className="space-y-1" data-testid={tid}>
      <div className="flex items-baseline justify-between text-sm">
        <span className="text-slate-600">{label}</span>
        <span className="tabular-nums"><b>{behaald}</b>{doel != null ? ` / ${doel}` : ""}{pct != null ? <span className="text-slate-500"> ({pct}%)</span> : ""}</span>
      </div>
      {doel != null && (
        <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
          <div className={`h-full rounded-full transition-[width] duration-700 ${kleur(pct)}`} style={{ width: `${Math.min(100, pct || 0)}%` }} />
        </div>
      )}
    </div>
  );
}

/** Besluit 3-11 (vervolg 3): eigen weekdoel inplannen op de startpagina — alleen de eigen cijfers (KCC, Salesteam, Accountmanager altijd). */
export function MijnWeekdoelKaart() {
  const [d, setD] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/vaste-klanten/rapport/mijn-weekdoel").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d?.toon) return null;
  const doel = d.doel;
  return (
    <Card className="p-4 space-y-3" data-testid="mijn-weekdoel-kaart">
      <div className="flex flex-wrap items-center gap-2">
        <Target className="w-5 h-5 text-[#EF3528]" />
        <h2 className="font-semibold">Mijn weekdoel inplannen</h2>
        <span className="text-xs text-slate-500">week {d.weeknummer} · {d.van.slice(8, 10)}-{d.van.slice(5, 7)} t/m {d.tot.slice(8, 10)}-{d.tot.slice(5, 7)}</span>
        <div className="flex-1" />
        <button type="button" onClick={() => nav("/vaste-klanten")} className="text-xs font-semibold text-blue-700 hover:text-blue-900" data-testid="mijn-weekdoel-naar-vk">Naar Vaste klanten</button>
      </div>
      <div className="grid gap-3 sm:grid-cols-3">
        <Balk label="Nederland" behaald={d.NL} doel={doel?.NL} pct={d.pct?.NL} tid="mijn-weekdoel-nl" />
        <Balk label="België" behaald={d.BE} doel={doel?.BE} pct={d.pct?.BE} tid="mijn-weekdoel-be" />
        <Balk label="Totaal" behaald={d.totaal} doel={doel?.totaal} pct={d.pct?.totaal} tid="mijn-weekdoel-totaal" />
      </div>
      <p className="text-xs text-slate-500" data-testid="mijn-weekdoel-uitleg">
        {doel ? "Telt elke vaste klant die u deze week op 'Afspraak ingepland' zet (één keer per klant)." : "Er is (nog) geen weekdoel voor u ingesteld; u ziet hoeveel klanten u deze week op 'Afspraak ingepland' heeft gezet."}
        {` Vorige week: ${d.vorige_totaal}.`}
      </p>
    </Card>
  );
}
